import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ---- announcements (public)
export const getActiveAnnouncements = async () => {
  const { data } = await axios.get(`${API}/announcements/active`);
  return data.map((a) => ({ ...a, id: a._id || a.id }));
};

// ---- admin token helpers
const TOKEN_KEY = "eyb_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data.user;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, authHeader());
  return data;
};

export const adminListAnnouncements = async () => {
  const { data } = await axios.get(`${API}/admin/announcements`, authHeader());
  return data.map((a) => ({ ...a, id: a._id || a.id }));
};

export const adminCreateAnnouncement = async (payload) => {
  const { data } = await axios.post(`${API}/admin/announcements`, payload, authHeader());
  return data;
};

export const adminUpdateAnnouncement = async (id, payload) => {
  const { data } = await axios.patch(`${API}/admin/announcements/${id}`, payload, authHeader());
  return data;
};

export const adminDeleteAnnouncement = async (id) => {
  const { data } = await axios.delete(`${API}/admin/announcements/${id}`, authHeader());
  return data;
};

export const adminPushCount = async () => {
  const { data } = await axios.get(`${API}/admin/push/count`, authHeader());
  return data.count;
};

// ---- web push
function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isPushEnabled = async () => {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return false;
  const sub = await reg.pushManager.getSubscription();
  return !!sub;
};

export const enablePush = async () => {
  if (!pushSupported())
    throw new Error("Notifications aren't supported here. On iPhone, add the app to your Home Screen first.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications permission was not granted.");

  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.publicKey),
    });
  }
  await axios.post(`${API}/push/subscribe`, sub.toJSON());
  return true;
};
